import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { NARMADAPURAM, MOST_READ } from "@/data/news";
import { ShareRow } from "@/components/site/Share";
import AdSlot from "@/components/site/AdSlot";
import api from "@/lib/api";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const shareUrlFor = (slug) => (slug ? `${BACKEND}/api/share/${slug}` : undefined);

export default function NarmadapuramGrid({ items }) {
  const data = items && items.length ? items : NARMADAPURAM;
  const [trending, setTrending] = useState(null);

  useEffect(() => {
    let alive = true;
    api.get("/public/trending?limit=6")
      .then((r) => { if (alive && r.data) setTrending(r.data); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);
  return (
    <section
      data-testid="narmadapuram-grid"
      className="bg-[#F4F4F0] border-b border-[#0F0F0F]/15"
    >
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-14 md:py-20">
        <div className="flex items-end justify-between mb-8 md:mb-12 flex-wrap gap-4">
          <div>
            <div className="eyebrow text-[#D92525] mb-3">फ़ोकस · नर्मदापुरम संभाग</div>
            <h2 className="font-serif-dev font-black text-[38px] md:text-[54px] leading-[1.02]">
              नर्मदापुरम, <span className="italic text-[#D92525]">सुबह से शाम तक</span>
            </h2>
          </div>
          <a href="/category/narmadapuram" data-testid="narmadapuram-more" className="font-sans-dev text-[12px] tracking-[0.24em] uppercase link-underline">
            संभाग की सभी ख़बरें →
          </a>
        </div>

        <div className="grid grid-cols-12 gap-6 md:gap-10">
          {/* Story list */}
          <div className="col-span-12 lg:col-span-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-10">
              {data.map((n, i) => (
                <motion.a
                  key={n.id}
                  href={n.slug ? `/news/${n.slug}` : "#"}
                  data-testid={`narmadapuram-story-${n.id}`}
                  initial={{ opacity: 0, y: 24 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-80px" }}
                  transition={{ duration: 0.6, delay: i * 0.08 }}
                  className="group block"
                >
                  <div className="thumb-wrap aspect-[4/3] mb-4 border border-[#0F0F0F]/15">
                    <img src={n.img} alt={n.title} className="w-full h-full object-contain" />
                  </div>
                  <div className="eyebrow text-[#D92525] mb-2">{n.kicker} · {n.time}</div>
                  <h3 className="font-serif-dev font-bold text-[20px] md:text-[22px] leading-[1.25] headline-link">
                    {n.title}
                  </h3>
                  <div className="mt-4 pt-3 border-t border-[#0F0F0F]/10">
                    <ShareRow title={n.title} url={shareUrlFor(n.slug)} testid={`share-narmadapuram-${n.id}`} />
                  </div>
                </motion.a>
              ))}
            </div>
          </div>

          {/* Sidebar: सबसे ज्यादा पढ़ी गई */}
          <aside className="col-span-12 lg:col-span-4">
            <div className="lg:sticky lg:top-32 border border-[#0F0F0F] bg-white p-6 md:p-7">
              <div className="flex items-center justify-between mb-6 pb-3 border-b border-[#0F0F0F]">
                <span className="font-serif-dev font-black text-[20px]">सबसे ज़्यादा पढ़ी गई</span>
                <span className="eyebrow text-[#D92525]">Trending</span>
              </div>
              <ol className="space-y-5">
                {(trending && trending.length ? trending : MOST_READ.map((t) => ({ title: t, slug: "" }))).map((m, i) => (
                  <li key={i} className="flex gap-4">
                    <span className="font-serif-dev italic text-[#D92525] text-[32px] leading-none w-8 shrink-0">
                      {i + 1}
                    </span>
                    <a
                      data-testid={`mostread-${i}`}
                      href={m.slug ? `/news/${m.slug}` : "#"}
                      className="font-serif-dev font-bold text-[15px] md:text-[16px] leading-snug headline-link"
                    >
                      {m.title || m}
                    </a>
                  </li>
                ))}
              </ol>
            </div>
            <div className="mt-6 hidden lg:block">
              <AdSlot variant="tall" testid="ad-narmadapuram-sidebar" />
            </div>
          </aside>
        </div>

        {/* Full-width in-content ad */}
        <div className="mt-14">
          <AdSlot variant="leaderboard" testid="ad-narmadapuram-mid" />
        </div>
      </div>
    </section>
  );
}
